import React, {useEffect, useRef} from 'react';
import FieldWrapper from "v4/components/form/FieldWrapper/FieldWrapper";
import {useFormRenderContext} from "v4/components/form/FormRender/context/FormRenderContext";
import { deepObjectsMerge } from "v4/utils/deepObjectsMerge";

/**
 *
 * @param {string} fieldName
 * @param {string} [className]
 * @param {Function} [onChange]
 * @param {Function} [fieldRender]
 * @param {Object} [overrideField]
 * @param {boolean} [isUnregistered]
 */
export default function FormRow({fieldName, className, onChange, fieldRender, overrideField = {}, isUnregistered = false}) {
    const {
        fields,
        setFieldRendered,
        fieldRender: fieldRenderFromContext,
        renderedFields,
        formRenderMethods
    } = useFormRenderContext();
    const canRender = useRef(renderedFields[fieldName]);
    const field = deepObjectsMerge(fields.find(field => field.name === fieldName && !canRender.current) ?? {}, overrideField);
    setFieldRendered(fieldName);

    useEffect(() => {
        if (!isUnregistered) return;

        formRenderMethods.unregister(fieldName);
    }, [fieldName, formRenderMethods, isUnregistered]);

    if (!field.name || isUnregistered) return null;

    if (fieldRender) return fieldRender(field, formRenderMethods);

    if (fieldRenderFromContext) return fieldRenderFromContext(field, formRenderMethods);

    return (
        <FieldWrapper key={field.id ?? field.name}
                      name={field.name}
                      className={className}
                      field={field}
                      onChange={onChange}/>
    )
}
